import React from 'react'
import styled from '@emotion/styled'
import { RfqWidget } from '@jelly/components'
import { string } from 'prop-types'
import { array } from 'prop-types'

const WidgetSection = styled.section`
	background: linear-gradient(180deg, #003b5c 0%, #126898 100%);
	padding: 4rem 0;

	${({ theme }) => theme.MQ.L} {
		padding: 8rem 0;
		flex-direction: row;
	}
`
const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin: 0 auto;
	width: 95%;

	${({ theme }) => theme.MQ.L} {
		flex-direction: row;
		${({ theme }) => theme.maxWidth.L};
	}
`
const LeadInTextWrapper = styled.div`
	color: ${({ theme }) => theme.colors.white};

	${({ theme }) => theme.MQ.L} {
		max-width: 500px;
		padding-right: 1.25rem;
	}

	h2 {
		${({ theme }) => theme.fonts.primarySemiBold};
		font-size: 2.25rem;
		line-height: 3.125rem;
		margin-top: 0;

		${({ theme }) => theme.MQ.L} {
			font-size: 2.625rem;
		}
	}

	h3 {
		color: ${({ theme }) => theme.colors.orange};
		${({ theme }) => theme.fonts.primary};
		font-size: 1.5rem;
		line-height: 2rem;
	}

	ul {
		padding: 0 1.25rem;
		font-size: 1.125rem;

		${({ theme }) => theme.MQ.L} {
			font-size: 1.3125rem;
		}
	}

	li {
		margin-bottom: 0.5rem;
		padding: 0 0.5rem;
		text-align: left;
		word-break: break-word;

		&::marker {
			color: ${({ theme }) => theme.colors.orange};
			font-size: 1.25rem;
		}
	}
`
const WidgetWrapper = styled.div`
	width: 100%;
	max-width: 640px;
	margin: 0 auto;

	.bzWidget {
		border-radius: 15px;
		border: ${({ theme }) => `4px solid ${theme.colors.gray[400]}`};
	}

	${({ theme }) => theme.MQ.L} {
		margin-left: auto;
	}
`
RfqWidgetSection.propTypes = {
	title: string.isRequired,
	bullets: array.isRequired,
	widgetId: string.isRequired,
}
export function RfqWidgetSection({ bullets, title, widgetId }) {
	return (
		<WidgetSection id="widget">
			<ContentWrapper>
				<LeadInTextWrapper>
					<h2>Not sure where to start? Let us do the work for you… </h2>
					<h3>{title}</h3>

					<ul>
						{bullets.map((bullet, i) => {
							return <li key={i}>{bullet}</li>
						})}
					</ul>
				</LeadInTextWrapper>

				<WidgetWrapper>
					{/* the default publisher id is for testing on staging */}
					<RfqWidget
						publisherId={process.env.GATSBY_WIDGET_ENV === 'PROD' ? '57290' : '203428'}
						widgetCategoryId={widgetId}
					/>
				</WidgetWrapper>
			</ContentWrapper>
		</WidgetSection>
	)
}
